import React, { createRef, ReactNode } from "react";
import { NativeHtml } from "../../../../types/nativeHtml";

type ActivateProps = {
	onClick?: any;
	onFocus?: any;
	onBlur?: any;
	children?: ReactNode;
	bsRole: string;
};
const ActivateFc: React.FC<ActivateProps & NativeHtml> = ({
	onClick,
	onBlur,
	children,
	className,
}) => {
	let ref = createRef<HTMLAnchorElement>();
	const handleClick = (e) => {
		e.preventDefault();
		onClick(e);
	};

	return (
		<>
			{/*eslint-disable-next-line*/}
			<a
				ref={ref}
				href="#"
				className={className}
				style={{ textDecoration: "none" }}
				onClick={handleClick}
			>
				{children}
			</a>
		</>
	);
};

class ToggleLink extends React.Component<ActivateProps & NativeHtml> {
	render() {
		return (
			<ActivateFc
				className={this.props.className}
				bsRole="toggle"
				onClick={this.props.onClick}
			>
				{this.props.children}
			</ActivateFc>
		);
	}
}

export default ToggleLink;
